













































































































import { computed, defineComponent, ref, useContext } from '@nuxtjs/composition-api'
import { PropType } from 'vue';
import { getAdditionalPriceLabel, getFirstPriceLabel, getSecondPriceLabel } from '~/utils/helpers/product';
import { OfferGroup } from '~/utils/types/ProductPage';
import PaymentFrequencySwitcher from '../PaymentFrequencySwitcher.vue';
import AddToCart from '~/components/solepro/AddToCart.vue';
import { getIsBook } from '~/utils/solepro/products';
import { useConfig } from '~/composables';
import { ADD_TO_CART_TIPO_ABBONAMENTO_PARAMS } from '~/utils/constants/product';
import ConfigureBundle from '../ConfigureBundle.vue';
import ClientOnly from 'vue-client-only';

import Teleport from 'vue2-teleport';
import { getOptionFirstlabel, getOptionSecondlabel } from '~/utils/solepro/prices';
export default defineComponent({
    props: {
        offerGroup: {
            type: Object as PropType<OfferGroup>,
            required: true
        },
        cardsQty: {
            type: Number,
            required: true
        },
        useCarousel: {
            type: Boolean,
            required: true
        },
        showFrequencies: {
            type: Boolean, default: true
        }

    },
    components: {
        PaymentFrequencySwitcher,
        AddToCart,
        ConfigureBundle,
        Teleport,
        ClientOnly
    },
    data() {
        return {
            hasFrequencies: false
        }
    },
    setup(props) {
        const { app: { i18n }, $fc } = useContext();
        const { config: storeConfig } = useConfig();
        const selectOpened = ref(false)
        /** sku or sku||variantsku */
        const productSkuSelected = ref(props.offerGroup.products[0].sku + (props.offerGroup.products[0].currentVariant ? `||${props.offerGroup.products[0].currentVariant.sku}` : '')); /** preselect first item */

        const reloadTrick = ref(true);
        const paymentFrequencyChoosen = ref();
        const firstPriceLabel = ref();
        const secondPriceLabel = ref();
        const addictionalLabel = ref();



        const setLabels = (product) => {
            if (product.currentVariant) {
                /** @TODO check, c'è sempre solo 1 combinazione? */
                const optionSet = product.optionsToSelect.find(el => !['tipo_abbonamento', 'tipo_consegna'].includes(el.attribute_code) && Object.keys(product.currentVariant).includes(el.attribute_code))
                const option = optionSet.options.find(el => el.value_index == product.currentVariant[optionSet.attribute_code])
                firstPriceLabel.value = isBook.value && option.cost ? $fc(option.cost) : getOptionFirstlabel(product, { ...option, attribute_code: optionSet.attribute_code }, paymentFrequencyChoosen.value, i18n, $fc)
                secondPriceLabel.value = isBook.value && option.cost ? 'prezzo IVA inclusa' : getOptionSecondlabel(product, { ...option, attribute_code: optionSet.attribute_code }, paymentFrequencyChoosen.value, i18n, $fc)
                addictionalLabel.value = null;
            } else {
                const pfc = paymentFrequencyChoosen.value ? paymentFrequencyChoosen.value : (product.paymentFrequencies[1] ?? product.paymentFrequencies[0])
                firstPriceLabel.value = getFirstPriceLabel(product, pfc, i18n, $fc)
                secondPriceLabel.value = getSecondPriceLabel(product, pfc, i18n, $fc)
                addictionalLabel.value = getAdditionalPriceLabel(product, pfc, i18n, $fc)
            }
        }
        /*const selectedProduct = computed(() => {
            const splitted = productSkuSelected.value.split('||');
            const variantSku = splitted.length > 1 ? splitted[1] : null;
            return props.offerGroup.products.find(el => el.sku == splitted[0] && (!variantSku || (variantSku && variantSku == el.currentVariant.sku)))

        })*/
        const sanitizedSku = computed(() => productSkuSelected.value + '"]'.replace(/\./g, ''))
        const isBook = computed(() => getIsBook(selectedProduct.value))


        const addToCartBtns = computed(() => {
            let atcb = ['Aggiungi al carrello'];
            if (selectedProduct.value.directCheckoutLabel && selectedProduct.value.directCheckoutLabel.trim() != '') {
                atcb.push(selectedProduct.value.directCheckoutLabel)
            } else {
                atcb.push(!!selectedProduct.value.autoRenew ? 'Abbonati in un click' : 'Acquista in un click')
            }
            return atcb
        })

        const productConfiguration = computed(() => {
            let confs = selectedProduct.value.hasPaperToAdd ? { [productSkuSelected.value]: { shippingType: 'Posta' } } : null /*@TODO check used to manage bundle-gpf*/
            if (selectedProduct.value.currentVariant) {
                selectedProduct.value.configurable_options.filter(el => el.attribute_code != 'tipo_consegna').forEach(el => {
                    if (!confs) confs = {};
                    confs[el.attribute_uid] = el.values.find(opt => opt.value_index == selectedProduct.value.currentVariant[el.attribute_code])
                })
            }
            return confs;
        })
        const tipoConsegna = computed(() => selectedProduct.value.hasPaperToAdd ? 'posta' : null); //@TODO check)

        const modulesToAdd = computed(() => selectedProduct.value.requiredModules.length > 0 ? selectedProduct.value.requiredModules.map(module => module.product.sku) : [])

        //props.offerGroup.products.find(el => el.sku == splitted[0] && (!variantSku || (variantSku && variantSku == el.currentVariant.sku)))
        const splitted = productSkuSelected.value.split('||');
        const variantSku = splitted.length > 1 ? splitted[1] : null;
        const selectedProduct = ref(props.offerGroup.products.find(el => el.sku == splitted[0] && (!variantSku || (variantSku && variantSku == el.currentVariant.sku))))

        return {
            productSkuSelected, /*sku or sku||variantsku*/
            selectedProduct,
            paymentFrequencyChoosen, /**@TODO manage */
            firstPriceLabel,
            secondPriceLabel,
            addictionalLabel,
            sanitizedSku,
            isBook,
            setLabels,
            scalapaySelector: '["#campaign-price-container-secondary-' + sanitizedSku + '","#campaign-price-container-' + sanitizedSku + '"]',
            email: storeConfig.value.general_contact_email,
            addToCartBtns,
            productConfiguration,
            ADD_TO_CART_TIPO_ABBONAMENTO_PARAMS,
            tipoConsegna,
            modulesToAdd,
            reloadTrick,
            selectOpened
        }
    },
    mounted() {
        const selectRef = (this.$refs.selectRef as HTMLElement)
        if (!selectRef) return
        selectRef.addEventListener('blur', this.selectBlur);
    },
    beforeDestroy() {
        const selectRef = (this.$refs.selectRef as HTMLElement)
        if (!selectRef) return
        selectRef.removeEventListener('blur', this.selectBlur);
    },
    watch: {
        productSkuSelected() {
            this.reloadTrick = false;
            setTimeout(() => {
                this.reloadTrick = true;
                this.$emit('change')
            }, 5)
        }
    },
    methods: {
        toggleSelect(){
            this.selectOpened = !this.selectOpened
        },

        selectBlur() {
            this.selectOpened=false
        },
        changeFrequency(val) {
            this.paymentFrequencyChoosen = val;
            this.setLabels(this.selectedProduct)
        },
        /**
       * productSkuSelected: sku or sku||variantsku
       */
        changeProduct() {
            this.reloadTrick = false;
            const splitted = this.productSkuSelected.split('||');
            const variantSku = splitted.length > 1 ? splitted[1] : null;
            const sp = this.offerGroup.products.find(el => el.sku == splitted[0] && (!variantSku || (variantSku && variantSku == el.currentVariant.sku)))
            this.selectedProduct = sp;
            this.$nextTick(()=>{
                this.reloadTrick=true
                this.setLabels(sp)
            })
        }
    }
})
